import { useEffect, useState } from "react";
import {
  ConnectGroupButtonData,
  ConnectGroupModalSteps,
  JoinGroupButtonType,
} from "@shared/features/newMarketplace/types";
import { LanguageNameSpaces, OpenMessage } from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

const useConnectGroupModal = (
  modalData: ConnectGroupButtonData,
  closeModal: () => void,
  openLink: (link: string) => void,
  openMessage: OpenMessage
) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.MARKETPLACE);

  const [isChecked, setIsChecked] = useState(false);
  const [showError, setShowError] = useState(false);
  const [step, setStep] = useState(ConnectGroupModalSteps.CONNECT_GROUP);

  const showSteps =
    modalData.buttonText === t(JoinGroupButtonType.SUBSCRIBE) ||
    modalData.buttonText === t(JoinGroupButtonType.START_FREE_TRIAL);

  useEffect(() => {
    if (isChecked) setShowError(false);
  }, [isChecked]);

  const onCloseModal = () => {
    closeModal();
    modalData.onClose?.();
    setIsChecked(false);
    setShowError(false);
    setStep(ConnectGroupModalSteps.CONNECT_GROUP);
  };

  const onClickContinue = () => {
    if (!isChecked) setShowError(true);
    else if (showSteps) {
      if (step === ConnectGroupModalSteps.CONNECT_GROUP) {
        modalData.onContinue?.().then(() => {
          openMessage(modalData.continueSuccessMessage || "", "success");
          setStep(ConnectGroupModalSteps.AUTO_TRADING);
        });
      }
    } else if (modalData.link) {
      openLink(modalData.link);
      onCloseModal();
    }
  };

  return {
    showError,
    onClickContinue,
    isChecked,
    setIsChecked,
    onCloseModal,
    step,
    showSteps,
  };
};

export default useConnectGroupModal;
